import {
  Typography,
  DialogProps,
  Button,
  Box
} from '@mui/material'
import { DialogBase } from 'components/dialog'

type MessageDialogProps = {
  message: string
  description?: string
	icon?: React.ReactNode
	label?: string
  onClose: () => void
} & Omit<DialogProps, "open" | "onClose" | "onSubmit">
export const MessageDialog = ({
  message,
  description,
	icon,
	label,
  onClose,
  ...others
}: MessageDialogProps) => {
  return (
    <DialogBase
      open
      onSubmit={() => onClose()}
      onClose={onClose}
      body={
        <Box paddingBottom={2} paddingX={2}>
          <Typography component="b" variant="body2" fontSize="20px">
            {message}
          </Typography>
          {description && (
            <Typography component="b" variant="body2" fontSize="20px">
              {description}
            </Typography>
          )}
        </Box>
      }
      action={{
        center: (
          <Button
            variant="contained"
            startIcon={icon}
            onClick={onClose}
          >
            {label ?? "閉じる"}
          </Button>
        )
      }}
      {...others}
    />
  )
}
